import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import PublicLayout from "@/components/PublicLayout";
import ScrollToTop from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Products from "@/pages/Products";
import FiveRangeDetail from "@/pages/FiveRangeDetail";
import Manufacturing from "@/pages/Manufacturing";
import Quality from "@/pages/Quality";
import ContractManufacturing from "@/pages/ContractManufacturing";
import Certifications from "@/pages/Certifications";
import Gallery from "@/pages/Gallery";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";



export default function App() {
  return (
    <SettingsProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Toaster
          position="top-right"
          toastOptions={{
            classNames: { toast: "bg-white text-[#0B2545] border border-slate-200" },
          }}
        />
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<Products />} />
            <Route path="/five-range/:slug" element={<FiveRangeDetail />} />
            <Route path="/manufacturing" element={<Manufacturing />} />
            <Route path="/quality" element={<Quality />} />
            <Route path="/contract-manufacturing" element={<ContractManufacturing />} />
            <Route path="/certifications" element={<Certifications />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
          </Route>


        </Routes>
      </BrowserRouter>
      </AuthProvider>
    </SettingsProvider>
  );
}
